var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchiveItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_6831_21956",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_6831_21956)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.38141 14.1357C2.96163 14.1357 2.60391 13.9879 2.30825 13.6922C2.01258 13.3966 1.86475 13.0389 1.86475 12.6191V3.38141C1.86475 2.96164 2.01258 2.60391 2.30825 2.30825C2.60391 2.01258 2.96163 1.86475 3.38141 1.86475H12.6191C13.0389 1.86475 13.3966 2.01258 13.6922 2.30825C13.9879 2.60391 14.1357 2.96164 14.1357 3.38141V12.6191C14.1357 13.0389 13.9879 13.3966 13.6922 13.6922C13.3966 13.9879 13.0389 14.1357 12.6191 14.1357H3.38141ZM8.00025 10.6431C8.3478 10.6431 8.67025 10.5554 8.96758 10.3799C9.26491 10.2046 9.50541 9.96958 9.68908 9.67491C9.76164 9.56536 9.85236 9.47708 9.96125 9.41008C10.0701 9.34319 10.1911 9.30975 10.3241 9.30975H12.6191V3.38141H3.38141V9.30975H5.67641C5.80941 9.30975 5.93036 9.34319 6.03925 9.41008C6.14814 9.47708 6.23886 9.56536 6.31141 9.67491C6.49508 9.96958 6.73558 10.2046 7.03291 10.3799C7.33025 10.5554 7.65269 10.6431 8.00025 10.6431Z",
  fill: "currentColor"
}))));
export default SvgArchiveItem;